{
  "page": {
    "refreshed": "刷新于 {{when}}",
    "failedToLoad": "加载分析数据失败:",
    "initializing": "分析模块正在初始化",
    "initializingBody": "分析模块正在准备首份快照。数据就绪后本页将自动刷新(通常在 60 秒以内)。",
    "outdatedTitle": "分析数据可能已过期",
    "outdatedBody": "上次成功刷新:{{when}}。最近一次尝试失败:{{error}}",
    "refreshedUnknown": "未知",
    "noWorkspacesTitle": "暂无 {{type}} 工作区",
    "noWorkspacesBody": "该服务类型下没有可聚合的工作区。请在上方切换服务类型,或在创建第一个工作区后再回到此页。"
  },
  "filters": {
    "preset7d": "7 天",
    "preset30d": "30 天",
    "preset90d": "90 天",
    "preset1yr": "1 年",
    "custom": "自定义",
    "customRange": "自定义:{{from}} – {{to}}",
    "customDateRange": "自定义日期范围",
    "from": "从",
    "to": "至",
    "apply": "应用",
    "clear": "清除",
    "all": "全部",
    "filterColumn": "筛选 {{label}}",
    "filterAria": "筛选 {{label}}",
    "noOptions": "无可选项",
    "clearFilters": "清除筛选",
    "sortLabel": "排序:{{column}} {{direction}}"
  },
  "time": {
    "justNow": "刚刚",
    "minAgo": "{{count}} 分钟前",
    "hourAgo_one": "{{count}} 小时前",
    "hourAgo_other": "{{count}} 小时前",
    "dayAgo_one": "{{count}} 天前",
    "dayAgo_other": "{{count}} 天前",
    "minAgoShort": "{{count}} 分前",
    "hourAgoShort": "{{count}} 时前",
    "dayAgoShort": "{{count}} 天前"
  },
  "kpi": {
    "totalWorkspaces": "工作区总数",
    "totalWorkspaces_validation": "验证总数",
    "totalWorkspaces_auditing": "审计总数",
    "totalWorkspaces_development": "开发总数",
    "totalWorkspacesTooltip": "上方所选服务类型的工作区数量。选择“全部服务类型”可查看整个组合的总数。",
    "completed": "已完成",
    "completedSubClean": "{{clean}} 个无问题 · {{withErrors}} 个有问题",
    "completedSubPercent": "占总数 {{percent}}%",
    "totalIssues": "问题总数",
    "issuesBySeverity": "T1:{{t1}} · T2:{{t2}} · T3:{{t3}} · T4:{{t4}}",
    "timeSaved": "节省时间",
    "timeSavedNoData": "暂不可用 — 未记录完成时间",
    "timeSavedSub_one": "≈ {{weeks}} 个全职人周 · 基于 {{count}} 个已计量工作区",
    "timeSavedSub_other": "≈ {{weeks}} 个全职人周 · 基于 {{count}} 个已计量工作区",
    "timeSavedSubWeeksOnly": "≈ {{weeks}} 个全职人周",
    "timeSavedTooltip": "基于假定基准的估算值。对每个已完成的工作区,以 120 小时为基准——即在不使用本流程的情况下完成一次完整验证(含规划、数据准备、分析与撰写)的假定工时——减去从工作区创建到进入最终状态实际耗费的时间,再将各工作区的结果相加。该 120 小时是对所有工作区一律套用的假定值,并非逐个项目实测得出。仅统计本项计量启用之后进入最终状态的工作区。启用时即已存在的工作区会被标记为早于本项计量,并永久不计入其中——其完成时刻从未被记录,也不会事后推算——因此该数值只覆盖部分工作区,而非全部。数值下方的说明会注明该结果基于多少个工作区。",
    "timeSavedTooltipNoData": "暂不可用。统计节省时间需要知道每个工作区的完成时间，而此视图中没有任何已完成的工作区记录了完成时间，因此无从测算。",
    "totalRuns30d": "近 30 天运行数",
    "activeRuns": "进行中运行",
    "successRate": "成功率",
    "avgTime": "平均耗时"
  },
  "severity": {
    "fallback": "类型 {{n}}"
  },
  "sections": {
    "portfolioTitle": "组合总览",
    "portfolioDescription": "各主要服务领域的模型数量及其进展",
    "issuesOverviewTitle": "问题与风险总览",
    "issuesOverviewDescription": "整个组合的严重程度分布以及按模型的细分",
    "workspacePipelineTitle": "工作区流水线",
    "workspacePipelineDescription": "所有工作区 —— 各工作区的章节进度、数据缺口及问题",
    "issuesDetailsTitle": "问题与风险详情",
    "issuesDetailsDescription": "根因问题，含支持性症状及工作区链接",
    "toolboxUsageTitle": "工具箱使用情况",
    "toolboxUsageDescription": "工作区工具箱中的工具运行情况",
    "consumptionTitle": "令牌消耗",
    "consumptionDescription": "本月 LLM 令牌使用情况 — 涵盖所有工作区和工具箱运行",
    "recentActivityTitle": "近期活动",
    "recentActivityDescription": "最近 24 小时的工作流状态切换"
  },
  "chart": {
    "rendering": "正在绘制图表…",
    "renderStalled": "此图表的绘制时间比平常更长。下方的数据不受影响。"
  },
  "portfolio": {
    "byVertical": "按垂直领域",
    "byProgress": "按进度",
    "byServiceType": "按服务类型",
    "serviceTypeLabels": {
      "validation": "验证",
      "auditing": "审计",
      "development": "开发"
    },
    "noWorkspaces": "暂无可展示的工作区。",
    "modelCount_one": "{{count}} 个模型",
    "modelCount_other": "{{count}} 个模型",
    "tooltipComplete": "{{completed}} / {{total}} 已完成 ({{percent}}%)",
    "tooltipPortfolioShare": "占组合 {{percent}}%",
    "loop": {
      "setup": "初始化",
      "plan": "规划",
      "data_prep": "数据准备",
      "report_gen": "报告生成",
      "review": "评审",
      "test_run": "测试运行",
      "complete": "完成",
      "failed": "失败"
    },
    "modelsLine_one": "{{count}} 个模型 (占 {{name}} 的 {{percent}}%)",
    "modelsLine_other": "{{count}} 个模型 (占 {{name}} 的 {{percent}}%)"
  },
  "issues": {
    "bySeverity": "按严重程度",
    "byVertical": "按垂直领域",
    "noIssues": "无问题",
    "noIssuesFound": "未发现问题",
    "searchPlaceholder": "搜索问题…",
    "filtered_one": "{{count}} 个问题",
    "filtered_other": "{{count}} 个问题",
    "issueCount_one": "{{count}} 个问题",
    "issueCount_other": "{{count}} 个问题",
    "columns": {
      "vertical": "垂直领域",
      "severity": "严重程度",
      "title": "标题",
      "theme": "主题",
      "attribution": "归属",
      "status": "状态",
      "workspace": "工作区",
      "details": "详情"
    },
    "attribution": {
      "md": "模型文档",
      "mv": "模型验证",
      "unset": "(未设置)"
    },
    "status": {
      "active": "活跃",
      "archived": "已归档"
    },
    "openWorkspace": "打开工作区 →",
    "openThisWorkspace": "打开此工作区",
    "openWorkspaceAria": "打开工作区 {{name}}",
    "expandedAria": "已展开 —— 点击行可折叠",
    "collapsedAria": "已折叠 —— 点击行可展开",
    "details": "详情"
  },
  "pipeline": {
    "searchPlaceholder": "搜索工作区…",
    "noWorkspaceData": "无工作区数据",
    "workspaceCount_one": "{{count}} 个工作区",
    "workspaceCount_other": "{{count}} 个工作区",
    "hideArchived": "隐藏已归档",
    "hideArchivedTooltip": "已归档工作区默认隐藏。点击可显示。",
    "showingArchived": "正在显示已归档",
    "stageBuckets": {
      "new": "新建",
      "planning": "规划中",
      "data_prep": "数据准备",
      "report_gen": "报告生成",
      "complete": "完成",
      "archived": "已归档"
    },
    "columns": {
      "workspace": "工作区",
      "vertical": "垂直领域",
      "stage": "阶段",
      "completenessVerdict": "完整性判定",
      "issues": "问题"
    },
    "completeWithErrors": "已完成 ⚠",
    "coverageVerdicts": {
      "insufficient": "不足",
      "partial": "部分",
      "adequate": "充分",
      "comprehensive": "全面",
      "unknown": "未评估"
    },
    "verdictTooltip": "完整性判定:{{verdict}}",
    "verdictNoCheck": "尚未记录完整性检查。",
    "openWorkspace": "打开工作区",
    "openWorkspaceAria": "打开工作区 {{name}}",
    "smeRating": "SME 评级:{{value}}",
    "statusTooltip": "状态:{{value}}",
    "statusTooltip_validation": "验证状态:{{value}}",
    "statusTooltip_auditing": "审计状态:{{value}}",
    "statusTooltip_development": "开发状态:{{value}}",
    "modal": {
      "createdOn": "创建于 {{date}}",
      "verticalLabel": "垂直领域",
      "stageLabel": "阶段",
      "completenessVerdictLabel": "完整性判定",
      "issuesPrompt": "问题 —— 点击卡片可在下方筛选",
      "allIssues": "全部问题",
      "filteredIssues": "{{label}} 问题",
      "filterCount": "显示 {{visible}} / {{total}} · 清除筛选",
      "noIssuesWorkspace": "此工作区尚未记录任何问题。",
      "noIssuesFilter": "没有符合当前严重程度筛选的问题。",
      "openWorkspaceAria": "打开工作区",
      "factsLabels": {
        "model": "模型",
        "modelId": "模型 ID",
        "version": "版本",
        "scope": "范围",
        "period": "期间",
        "status": "状态",
        "rating": "评级"
      }
    },
    "unknownVertical": "未知:{{value}}"
  },
  "stage": {
    "unknown": "未知:{{stage}}"
  },
  "recentActivity": {
    "unavailable": "近期活动不可用:{{error}}",
    "noActivity": "最近 24 小时无活动"
  },
  "toolboxUsage": {
    "noRuns": "暂无工具箱运行记录",
    "runsByTool": "按工具的运行数",
    "topFailures": "主要失败原因",
    "runsLabel": "{{label}} ({{count}} 次运行)",
    "succeeded": "成功",
    "failed": "失败",
    "cancelled": "已取消",
    "stale": "已停滞"
  },
  "consumption": {
    "totalTokens": "令牌总数",
    "inputTokens": "输入令牌",
    "outputTokens": "输出令牌",
    "calls": "LLM 调用次数",
    "noData": "本月尚无 LLM 使用记录",
    "tokensByModel": "按模型划分的令牌",
    "dailyTrend": "每日令牌趋势",
    "topWorkspaces": "主要工作区",
    "toolboxBucket": "工具箱（非工作区）",
    "input": "输入",
    "output": "输出",
    "cache": "缓存"
  },
  "controls": {
    "executive": "高管视图",
    "admin": "管理员视图",
    "scrollToTop": "回到顶部",
    "scrollToTopAria": "回到顶部"
  },
  "serviceTypeSelector": {
    "withGeneric": "{{count}} · {{generic}} 个通用",
    "all": "全部服务类型",
    "allShort": "全部"
  },
  "export": {
    "buttonLabel": "导出",
    "buttonTooltip": "将当前视图导出为 Excel 工作簿 (.xlsx)",
    "buttonAria": "将分析数据导出至 Excel",
    "buttonDisabledTooltip": "数据仍在加载",
    "generating": "生成中…",
    "errorTitle": "导出失败",
    "filenamePrefix": "bennie-analytics",
    "sheets": {
      "cover": "封面",
      "kpi": "KPI 汇总",
      "portfolio": "组合",
      "pipeline": "流水线",
      "issues": "问题",
      "toolbox": "工具箱使用情况"
    },
    "cover": {
      "title": "Bennie 分析导出",
      "generatedAt": "生成时间",
      "snapshotRefreshedAt": "快照刷新于",
      "serviceTypeFilter": "服务类型筛选",
      "dateRangeFilter": "日期范围",
      "allTime": "全部时间",
      "coveragePosture": "覆盖范围",
      "coveragePostureBody": "无论当前为“管理层”还是“管理员”视图，导出内容始终包含完整的管理员数据集。",
      "sheetIndex": "本工作簿包含的工作表",
      "rowCountSuffix": "({{count}} 行)"
    },
    "kpi": {
      "metric": "指标",
      "value": "数值",
      "subline": "备注",
      "totalWorkspaces": "工作区总数",
      "totalWorkspaces_validation": "验证总数",
      "totalWorkspaces_auditing": "审计总数",
      "totalWorkspaces_development": "开发总数",
      "completed": "已完成",
      "completedSub": "{{withErrors}} 个有问题",
      "totalIssues": "问题总数",
      "issuesSub": "T1:{{t1}} T2:{{t2}} T3:{{t3}} T4:{{t4}}",
      "timeSaved": "节省时间(小时)",
      "timeSavedSub": "基于 {{completed}} 个已完成工作区中的 {{measured}} 个。本项计量启用时即已存在的工作区不计入其中,其完成时刻不会事后推算。"
    },
    "portfolio": {
      "category": "类别",
      "workspaceCount": "工作区数量",
      "completedCount": "已完成数量",
      "type1": "类型 1",
      "type2": "类型 2",
      "type3": "类型 3",
      "type4": "类型 4"
    },
    "pipeline": {
      "workspaceId": "工作区 ID",
      "name": "工作区名称",
      "serviceType": "服务类型",
      "vertical": "垂直领域",
      "stage": "阶段",
      "coverageVerdict": "完整性判定",
      "type1": "类型 1",
      "type2": "类型 2",
      "type3": "类型 3",
      "type4": "类型 4",
      "createdAt": "创建时间",
      "updatedAt": "更新时间",
      "modelName": "模型名称",
      "modelId": "模型 ID",
      "scope": "范围",
      "scope_validation": "验证范围",
      "scope_auditing": "审计范围",
      "scope_development": "开发范围",
      "period": "期间",
      "period_validation": "验证期间",
      "period_auditing": "审计期间",
      "period_development": "开发期间",
      "rating": "评级",
      "status": "状态",
      "status_validation": "验证状态",
      "status_auditing": "审计状态",
      "status_development": "开发状态",
      "workspaceStatus": "工作区状态"
    },
    "issues": {
      "id": "问题 ID",
      "workspaceId": "工作区 ID",
      "workspaceName": "工作区名称",
      "serviceType": "服务类型",
      "severity": "严重程度",
      "title": "标题",
      "theme": "主题",
      "classification": "分类",
      "attribution": "归属",
      "primaryDimension": "主要维度",
      "rootCauseDescription": "根本原因",
      "supportingSymptoms": "支撑症状",
      "workspaceStatus": "工作区状态"
    },
    "toolbox": {
      "toolId": "工具 ID",
      "label": "标签",
      "totalRuns": "运行总数",
      "succeeded": "成功",
      "failed": "失败",
      "cancelled": "已取消",
      "stale": "已停滞",
      "interrupted": "已中断",
      "active": "进行中",
      "avgDurationMs": "平均耗时(毫秒)"
    }
  },
  "verticals": {
    "unresolved": "未识别垂直领域"
  }
}
